export default __webpack_public_path__ + "images/1e5c9d9e37e477f594cc95028e75a731.svg";